import CustomerEstimate from "./CustomerEstimate";
import Product from "./Product";
import InsulationCut from "./InsulationCut";
import BaseModel from "./BaseModel";

export default class CustomerEstimateItem extends BaseModel {

	static entity = 'customer_estimate_items';
	static route = 'customer-estimate-items';
	static plural = 'customer_estimate_items';
	static singular = 'customer_estimate_item';

	static fields () {
		return {
			id: this.attr(null), 

			customer_estimate_id: this.attr(null),
			customer_estimate: this.belongsTo(CustomerEstimate, 'customer_estimate_id'),
			product_id: this.attr(null),
			product: this.belongsTo(Product, 'product_id'),
			insulation_cut_id: this.attr(null),
			insulation_cut: this.belongsTo(InsulationCut, 'insulation_cut_id'),

			section: this.attr(null),
			quantity: this.attr(null),
			price: this.attr(null),
			tax_percent: this.attr(null),
			tax_decimal: this.attr(null),
			sum_tax: this.attr(null),
			sum_price: this.attr(null),
			total: this.attr(null),
			description: this.attr(null), 
			
			created_at: this.attr(null), 
			updated_at: this.attr(null), 
			deleted_at: this.attr(null)
		}
	}


	getItemName() {
		if(this.product) {
			if(this.product.name !== 'Other') {
				return this.product.getFilteredName();
			} else {
				return EstimateItem.decodeHTMLEntities(this.description);
			}
		}
	}

}
